
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/landingPages/PropertyResearchComboLandingPage",
      function () {
        return require("private-next-pages/landingPages/PropertyResearchComboLandingPage.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/landingPages/PropertyResearchComboLandingPage"])
      });
    }
  